import { Component, OnInit, Input, Renderer2, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { ScrollEventService } from '../scroll-event.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FocusService } from 'app/focus.service';

@Component({
  selector: 'fts-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
})
export class BackToTopComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  startingPointY = 150;
  @Input()
  scrollableElement: any;
  @Input()
  isHalfAndHalf = false;
  @Input()
  page?: 'editor' | 'menu';

  private destroy$: Subject<void> = new Subject();
  private unlisten: () => void;
  isVisible = false;
  faAngleUp = faAngleUp;

  constructor(private renderer: Renderer2, private scrollService: ScrollEventService, private focusService: FocusService) {
    this.setVisibility();
    this.unlisten = () => {};
  }

  ngOnInit() {
    this.scrollService.throttledScroll$.pipe(takeUntil(this.destroy$)).subscribe(() => this.setVisibility());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['scrollableElement'] && changes.scrollableElement.currentValue) {
      this.unlisten = this.renderer.listen(this.scrollableElement, 'scroll', event => {
        this.setVisibility();
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.unlisten();
  }

  setVisibility() {
    const scrollTop = this.scrollableElement
      ? this.scrollableElement.scrollTop
      : window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    const hasScrolling = this.scrollableElement
      ? this.scrollableElement.clientHeight < this.scrollableElement.scrollHeight
      : window.innerHeight <= document.body.offsetHeight;
    this.isVisible = hasScrolling && scrollTop > this.startingPointY;
    if (document.getElementById('back-to-top-btn')) {
      if (this.isVisible) {
        this.renderer.addClass(document.getElementById('back-to-top-btn'), 'visible');
      } else {
        this.renderer.removeClass(document.getElementById('back-to-top-btn'), 'visible');
      }
    }
  }

  backToTop() {
    if (this.scrollableElement) {
      setTimeout(() => {
        this.scrollableElement.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }, 0);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    this.focusService.applyFocus(this.page === 'menu' ? 'single-page-wrapper' : 'editor-panels-wrapper');
  }
}
